$(document).ready(function(){
 	$('.w-icon-dropdown-toggle').click(function(){
		var $drop = $(this).find('.w-dropdown-list');
	    if($drop.hasClass('show')) {
	        $drop.removeClass('show');
	    } else {
	  		$drop.addClass('show');
	    }
	});

	$('.w-dropdown').hover(function(){
		var $drop = $(this).find('.w-dropdown-list');
	  	$drop.toggleClass('show');
	});


	$('.address-new-toggle').click(function() {
		$('#AddressNewForm').toggleClass('show');
	})

	$('.address-edit-toggle').click(function() {
		$('.address-edit-form').toggleClass('show');
	})


	
})